// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// Runtime configuration with environment variable support
// Falls back to window.env for runtime injection, then process.env, then defaults

const getEnv = (key, defaultValue) => {
  // Check runtime window.env first (for runtime config injection)
  if (window.env && window.env[key] !== undefined) {
    return window.env[key];
  }
  // Check build-time process.env
  if (process.env[key] !== undefined) {
    return process.env[key];
  }
  return defaultValue;
};

const getBoolEnv = (key, defaultValue) => {
  const value = getEnv(key);
  if (value === undefined) {return defaultValue;}
  if (typeof value === "boolean") {return value;}
  return value === "true" || value === "1";
};

const getNumberEnv = (key, defaultValue) => {
  const value = getEnv(key);
  if (value === undefined) {return defaultValue;}
  const num = Number(value);
  return isNaN(num) ? defaultValue : num;
};

// API Configuration
export const ApiUrl = getEnv("REACT_APP_API_URL", "");

// Application Settings
export const DefaultApplication = getEnv("REACT_APP_DEFAULT_APPLICATION", "app-built-in");

export const CasvisorUrl = getEnv("REACT_APP_CASVISOR_URL", "");

// UI Settings
export const ShowGithubCorner = getBoolEnv("REACT_APP_SHOW_GITHUB_CORNER", false);
export const IsDemoMode = getBoolEnv("REACT_APP_IS_DEMO_MODE", false);

// Language Settings
export const ForceLanguage = getEnv("REACT_APP_FORCE_LANGUAGE", "");
export const DefaultLanguage = getEnv("REACT_APP_DEFAULT_LANGUAGE", "en");

// Theme Settings
export const InitThemeAlgorithm = getBoolEnv("REACT_APP_INIT_THEME_ALGORITHM", true);
export const ThemeDefault = {
  themeType: getEnv("REACT_APP_THEME_TYPE", "default"),
  colorPrimary: getEnv("REACT_APP_COLOR_PRIMARY", "#5734d3"),
  borderRadius: getNumberEnv("REACT_APP_BORDER_RADIUS", 6),
  isCompact: getBoolEnv("REACT_APP_IS_COMPACT", false),
};

export const CustomFooter = null;

// AI Assistant
export const AiAssistantUrl = getEnv("REACT_APP_AI_ASSISTANT_URL", "https://ai.casbin.com");

// UI Layout
export const MaxItemsForFlatMenu = getNumberEnv("REACT_APP_MAX_ITEMS_FOR_FLAT_MENU", 7);
